<div class="order-items-list" *ngIf="groups.length">
  <div class="order-items-list__summary">
    {{
      "printCardOrders.itemsSummary"
        | translate
          : {
              recipientCount: summary.recipientCount,
              lineCount: summary.lineCount,
              totalQuantity: summary.totalQuantity
            }
    }}
  </div>

  <div
    class="order-items-list__scroll"
    role="region"
    [attr.aria-label]="'printCardOrders.items' | translate"
  >
    <table
      class="order-items-table"
      [class.order-items-table--with-order]="showPrinterOrderColumn"
      [class.order-items-table--sticky]="showPrinterDetails"
    >
      <thead>
        <tr>
          <th scope="col" class="col-index col-sticky">#</th>
          <th
            scope="col"
            class="col-printer-order col-sticky"
            *ngIf="showPrinterOrderColumn"
          >
            {{ "printCardOrders.itemPrinterOrderNumber" | translate }}
          </th>
          <th scope="col" class="col-size col-sticky">
            {{ "printCardOrders.itemSize" | translate }}
          </th>
          <th scope="col" class="col-quantity">{{ "printCardOrders.itemQuantity" | translate }}</th>
          <th scope="col" class="col-template">{{ "printCardOrders.itemsTemplate" | translate }}</th>
          <th scope="col" class="col-type">{{ "printCardOrders.itemType" | translate }}</th>
          <th scope="col" class="col-orientation">
            {{ "printCardOrders.itemOrientation" | translate }}
          </th>
          <th
            scope="col"
            class="col-param"
            *ngFor="let labelKey of printerParameterColumns"
          >
            {{ labelKey | translate }}
          </th>
          <th scope="col" class="col-printer-name" *ngIf="showPrinterNameColumn">
            {{ "printCardOrders.itemPrinterName" | translate }}
          </th>
          <th scope="col" class="col-printer-status" *ngIf="showPrinterColumns">
            {{ "printCardOrders.itemPrinterStatus" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of groups">
          <tr class="order-items-table__group" *ngIf="showGroupHeaders">
            <th
              scope="rowgroup"
              class="order-items-table__group-leading"
              [attr.colspan]="leadingColumnCount"
            >
              <div class="order-items-table__group-main">
                <div class="order-items-table__group-identity">
                  <span class="order-items-table__group-name">{{ group.employeeName }}</span>
                  <span class="order-items-table__group-email">{{ group.employeeEmail }}</span>
                </div>
                <div
                  class="order-items-table__group-labels"
                  *ngIf="showNameLabelActions"
                >
                  <button
                    type="button"
                    mat-stroked-button
                    class="order-items-table__label-btn"
                    (click)="
                      nameLabelPrint.emit({
                        employeeEmail: group.employeeEmail,
                        withQr: true
                      })
                    "
                    [disabled]="!!nameLabelLoading"
                  >
                    <mat-spinner
                      class="dc-btn-spinner"
                      diameter="14"
                      *ngIf="nameLabelLoading === group.employeeEmail.trim().toLowerCase()"
                    ></mat-spinner>
                    {{ "printCardOrders.nameLabel.sticker30x15Qr" | translate }}
                  </button>
                </div>
              </div>
            </th>
            <th
              class="order-items-table__group-trailing"
              [attr.colspan]="trailingColumnCount"
            >
              <span class="order-items-table__group-meta">
                {{
                  "printCardOrders.itemsGroupMeta"
                    | translate
                      : {
                          lineCount: group.lineCount,
                          totalQuantity: group.totalQuantity
                        }
                }}
              </span>
            </th>
          </tr>
          <tr class="order-items-table__row" *ngFor="let row of group.rows">
            <td class="col-index col-sticky" data-label="#">{{ row.index }}</td>
            <td
              class="col-printer-order col-sticky"
              *ngIf="showPrinterOrderColumn"
              [attr.data-label]="'printCardOrders.itemPrinterOrderNumber' | translate"
            >
              <button
                type="button"
                class="order-items-table__order-link"
                *ngIf="canPreviewItem(group, row); else plainOrderNumber"
                (click)="openPreview(group, row, $event)"
                [attr.aria-label]="'printCardOrders.previewItem' | translate"
                [matTooltip]="'printCardOrders.preview' | translate"
                matTooltipPosition="above"
              >
                {{ getPrinterOrderNumber(row.item) || ("printCardOrders.preview" | translate) }}
              </button>
              <ng-template #plainOrderNumber>
                {{ getPrinterOrderNumber(row.item) || "—" }}
              </ng-template>
            </td>
            <td
              class="col-size col-sticky"
              [attr.data-label]="'printCardOrders.itemSize' | translate"
            >
              {{ getSizeLabel(row.item) }}
            </td>
            <td class="col-quantity" [attr.data-label]="'printCardOrders.itemQuantity' | translate">
              {{ row.item.quantity }} {{ "printCardOrders.quantityUnit" | translate }}
            </td>
            <td class="col-template" [attr.data-label]="'printCardOrders.itemsTemplate' | translate">
              <span class="order-items-table__template-cell">
                <span>{{ row.item.templateName }}</span>
                <span
                  class="order-items-table__group-blocked"
                  *ngIf="group.fulfillmentBlockedReason === fulfillmentBlockedReason.EMPLOYEE_DELETED"
                  [matTooltip]="
                    'printCardOrders.fulfillmentBlocked.EMPLOYEE_DELETED_tooltip'
                      | translate
                        : {
                            employeeName: group.employeeName,
                            employeeEmail: group.employeeEmail
                          }
                  "
                  matTooltipPosition="above"
                >
                  {{ "printCardOrders.fulfillmentBlocked.EMPLOYEE_DELETED_tag" | translate }}
                </span>
              </span>
            </td>
            <td class="col-type" [attr.data-label]="'printCardOrders.itemType' | translate">
              {{ getTypeLabelKey(row.item) | translate }}
            </td>
            <td
              class="col-orientation"
              [attr.data-label]="'printCardOrders.itemOrientation' | translate"
            >
              {{ getOrientationLabelKey(row.item) | translate }}
            </td>
            <td
              class="col-param"
              *ngFor="let labelKey of printerParameterColumns"
              [attr.data-label]="labelKey | translate"
            >
              {{ printerParameterValue(row.item, labelKey) || "—" }}
            </td>
            <td
              class="col-printer-name"
              *ngIf="showPrinterNameColumn"
              [attr.data-label]="'printCardOrders.itemPrinterName' | translate"
            >
              {{ row.item.printerName || "—" }}
            </td>
            <td
              class="col-printer-status"
              *ngIf="showPrinterColumns"
              [attr.data-label]="'printCardOrders.itemPrinterStatus' | translate"
            >
              {{ getPrinterStatusLabel(row.item) || "—" }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
